module.exports = __webpack_public_path__ + "media/g_3.451ca5bd.mp3";